import * as commonModule from './common';
import * as searchModule from './search-filter';
import './analytics';
import './thankyou';
import Alpine from 'alpinejs';
import './navbar';
import './stories-card';

window.Alpine = Alpine;
Alpine.start();

import { MDCTextField } from '@material/textfield';
import * as Sentry from '@sentry/browser';
import './form/form';
// eslint-disable-next-line
if (FYLE_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: 'https://3ec8e1b8c0961e88efe2c52461e1ec69@o341960.ingest.sentry.io/4506777705250816',
    ignoreErrors: [
      /undefined is not an object \(evaluating 'jobForm\.public_custom_field_ids'\)/,
    ],
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    tracesSampleRate: 0.1
  });
}

/*global LazyLoad, currentPathName */
window.currentPathName = window.location.pathname;

new LazyLoad({
  elements_selector: '.lazy',
  threshold: 350
});

window.mousemoveLazyLoad = new LazyLoad({
  elements_selector: '.lazy.mousemove-lazy',
});

// functions to be fired when the entire page loads (images, CSS, scripts)
$(window).on('load', () => {
  // Enable tooltips if used on the page
  if ($('[data-toggle="tooltip"]').length > 0) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  switch (currentPathName) {
    case '/alternative/certify':
    case '/alternative/concur':
    case '/alternative/expensify':
    case '/expense-report-software':
    case '/automated-expense-reporting':
    case '/travel-expense-management':
    case '/expense-reimbursement-software':
    case '/expense-management-software':
    case '/pricing':
    case '/chrome-uninstall':
    case '/solutions/industry/technology-expense-management':
    case '/solutions/industry/construction':
    case '/solutions/industry/non-profit-organizations':
    case '/solutions/industry/legal-services':
    case '/solutions/project-spends':
    case '/product/cards':
    case '/product/approvals':
    case '/product/analytics':
    case '/product/compliance':
    case '/product/payments':
    case '/product/integrations':
    case '/product/integrations/sage-intacct-accounting-software':
    case '/product/integrations/quickbooks-online-accounting-software':
    case '/product/integrations/travelperk-travel-software':
    case '/product/integrations/xero-accounting-software':
    case '/product/finance-operations':
    case '/product/expenses':
    case '/product/security':
    case '/product/releases':
    case '/product/mobile-app':
    case '/product/budgets':
    case '/product/cards/visa':
    case '/mastercard':
    case '/customers':
    case '/company/press':
    case '/customers/reviews':
    case '/schedule-demo':
    case '/product/integrations/netsuite-accounting-software':
    case '/partners/accounting-firms':
    case '/partner-referral':
    case '/product/expenses/slack':
    case '/expense-receipt-tracking':
    case '/ppc/home':
    case '/ppc/business-credit-card-management':
    case '/quickbooks-disconnected':
    case '/implementation/':
    case '/product/integrations/bamboo-hr':
    case '/product/integrations/quickbooks-desktop-accounting-software':
    case '/ppc/alternative/expensify':
    case '/product/':
    case '/product': {
      // Showing and hiding of collapse elements in all features (product) page
      searchModule.searchFilter();
      commonModule.collapseFeatureList();
      commonModule.setFooterMargin();
      break;
    }
   
    case '/partners': {
      commonModule.setFooterMargin();
      // Dynamically apply styling to the select option on Partner page
      $('select').on('change', (event) => {
        const target = event.currentTarget;
        const selectedOption = $(target).children(':selected').attr('class');
        $(target).attr('class', '').addClass(`mdc-text-field__input ${selectedOption}`);
      });
      break;
    }

    case '/templates/expense-reports/':
    case '/templates/expense-reports': {
      // Changing form title on '/templates/expense-reports' page
      $('#download-excel').click(() => {
        $('#report-heading').text('Download for excel');
        $('#report-subtext').text('Just fill out this small form, and get a copy of the template now.');
      });
      commonModule.setFooterMargin();
      break;
    }

    case '/company': {
      $('.company-read-all').click((event) => {
        $(event.currentTarget).text(
          $(event.currentTarget).text() === 'Read more' ? 'Read less' : 'Read more'
        );
      });
      commonModule.setFooterMargin();
      break;
    }
  }

  commonModule.saveSearchString();
  commonModule.collapsibleCard();
  commonModule.carouselNormalization();
  if (document.getElementById('customer-success-yt-videos')) {
    commonModule.videoCarousel();
  }
  commonModule.carouselTestimonial('#carousel');
  commonModule.carouselTestimonial('#clientCarousel');

  // To instantiate components for multiple elements at once
  [].map.call(document.querySelectorAll('.mdc-text-field'), (el) => new MDCTextField(el));
});

$(document).ready(() => {
  // Function to load images on mouse movement/touch start
  commonModule.loadImagesOnMouseMovement();

  if ($('.collapsible-card-header').length !== 0) {
    commonModule.collapsibleCard();
  }

  const showComparePricingSection = () => {
    // Pricing page
    if (currentPathName === '/pricing') {
      $('.show-hide-feature, .btn-compare-feature').click((event) => {
        // Show compare all feature section in pricing page
        if ($(event.currentTarget).hasClass('btn-compare-feature')) {
          $('.btn-compare-feature').hide();
          $('.feature-table').removeClass('d-none');
        } else {
          // Change text from 'show detail' to 'hide detail' when clicking to open features in mobile
          $(event.currentTarget).text(
            $(event.currentTarget).text() === 'HIDE DETAILS' ? 'SEE DETAILS' : 'HIDE DETAILS'
          );
        }
      });
    }
  };

  showComparePricingSection();

  // Save the IP address
  commonModule.saveIPAddress()
    .then((data) => commonModule.getIpInfo(data))
    .then(() => {
      // Trigger exit intent banner
      commonModule.triggerExitIntentBanner();
    })
    .catch(() => {
      if (localStorage.getItem('ipInfo') !== null) {
        localStorage.removeItem('ipInfo');
      }
    });

  if ($('#customer-carousel').length !== 0) {
    // Generate random testimonial on each page
    commonModule.testimonialRandomSelection('#customer-carousel');
    // On touch in carousel item on mobile
    document
      .getElementById('customer-carousel')
      .getElementsByClassName('carousel-inner')[0]
      .addEventListener(
        'touchstart',
        (event) => commonModule.mobileSwipeCarousel(event, '#customer-carousel'),
        { passive: true }
      );
  }

  if ($('#card-customer-carousel').length !== 0) {
    commonModule.testimonialRandomSelection('#card-customer-carousel');
    document
      .getElementById('card-customer-carousel')
      .getElementsByClassName('carousel-inner')[0]
      .addEventListener(
        'touchstart',
        (event) => commonModule.mobileSwipeCarousel(event, '#card-customer-carousel'),
        { passive: true }
      );
  }

  if ($('#employee-carousel').length !== 0) {
    document
      .getElementById('employee-carousel')
      .getElementsByClassName('carousel-inner')[0]
      .addEventListener(
        'touchstart',
        (event) => commonModule.mobileSwipeCarousel(event, '#employee-carousel'),
        { passive: true }
      );
  }

  // Generate random badge section if used
  if ($('.fyle-recognition-badges').length !== 0) {
    commonModule.badgesRandomSelection();
  }

  // Check if a modal is open on the page
  commonModule.checkModalIsOpen();

  // Check click outside to send GA event for demo form
  commonModule.clickOutsideToHideContent();

  // Check if any fields were edited in the demo form to send a GA event.
  commonModule.onEditDemoForm();

  if ($('.software-sneak-peek-section').length !== 0) {
    // Change section on hover in sneak-peek section
    commonModule.sneakPeekSectionHover();
  }

  $(window).scroll((event) => {
    // Fade in/out effect based on scroll top
    if ($(event.currentTarget).scrollTop() > 100) {
      $('.scroll-transition').fadeIn();
    } else {
      $('.scroll-transition').fadeOut();
    }

    // Sticky sidebar for slider section
    const stickySliderPages = [
      '/travel-expense-management',
      '/expense-software',
      '/best-business-credit-cards',
      '/templates/expense-reports'
    ];

    if (stickySliderPages.indexOf(currentPathName) > -1) {
      const sectionTop = document.getElementsByClassName('sticky-slider-feature-section')[0].offsetTop;
      const scrollPos = $(document).scrollTop() - sectionTop;
      $('.sticky-sidebar ul li').each((index, element) => {
        const currentMenuItem = $(element);
        const refElement = $(`.${currentMenuItem.attr('id')}`);
        if (refElement.position().top <= scrollPos) {
          $('.sticky-sidebar ul li').removeClass('active');
          currentMenuItem.addClass('active');
        }
      });
    }

    const stickySliderPagesWithDivider = [
      '/product/releases',
      '/product/approvals',
      '/product/expenses',
      '/product/analytics'
    ];

    if (stickySliderPagesWithDivider.indexOf(currentPathName) > -1) {
      const sliderSection = $('.sticky-slider-feature-section');
      const allListItems = $('.sticky-sidebar ul li');
      const navList = commonModule.getUniqueSideNavList(sliderSection, allListItems);
      // To keep track of the index of the active side nav.
      let index = 0;
      sliderSection.each((i, section) => {
        const sectionTop = section.offsetTop;
        const scrollPos = $(document).scrollTop() - sectionTop;
        const imgContainer = $(section).find('.slider-image-section-container');
        imgContainer.each((i) => {
          const currentMenuItem = $(navList[i + index]);
          const refElement = $(`.${currentMenuItem.attr('id')}`);
          if (refElement.position().top <= scrollPos + 10) {
            allListItems.removeClass('active');
            currentMenuItem.addClass('active');
          } else {
            if (i === 0) {
              $(navList[index]).addClass('active');
            }
          }
        });
        // Increment active index based on the number of headers in each slider section.
        index += imgContainer.length;
      });
    }

    // Generic slider pages (using the picture element to prevent images from loading on mobile)
    const genericStickySliderPages = ['/company/press'];
    if (genericStickySliderPages.indexOf(currentPathName) > -1) {
      const sectionTop = document.getElementsByClassName('generic-slider')[0].offsetTop;
      const scrollPos = $(document).scrollTop() - sectionTop;
      const sectionPadding = 100;
      $('.sticky-sidebar ul li').each((index, element) => {
        const currentMenuItem = $(element);
        const refElement = $(`.${currentMenuItem.attr('id')}`);
        // Calculate sidebar position relative to the class
        const sidebarPos = scrollPos + sectionTop + sectionPadding;
        if (refElement.position().top <= sidebarPos) {
          $('.sticky-sidebar ul li').removeClass('active');
          currentMenuItem.addClass('active');
        }
      });
      // Calculate the last sidebar list element’s position
      const lastElement = $('.sticky-sidebar ul li').last();
      const refElement = $(`.${lastElement.attr('id')}`);
      // Determine the relative upper & lower limits for sidebar visibility
      const sliderUpperLimit = scrollPos + sectionPadding;
      const sliderLowerLimit = refElement.position().top - sectionTop + sectionPadding;
      const sliderRange = sliderUpperLimit >= 0 && scrollPos <= sliderLowerLimit;
      $('.general-slider').toggleClass('show-active', sliderRange);
    }

    // Scroll-top functionality in the pricing page (inside the features table)
    if (currentPathName === '/pricing') {
      commonModule.scrollTopToggle('.pricing-feature-scroll-start', '.table-row:last', 80);
    }
  });

  // Active state for feature card pages
  const featureCardPages = [
    '/customer-success',
    '/expense-reimbursement-software',
    '/expense-management-software'
  ];

  if (featureCardPages.indexOf(currentPathName) > -1) {
    commonModule.setExpenseFeatureActive();
  }

  const activeCards = ['/company/', '/company', '/implementation/', '/implementation'];
  if (activeCards.indexOf(currentPathName) > -1) {
    commonModule.setCardsActive($('.card.active'));
    commonModule.companyTimelineAnimation();
  }

  // Hide cookie consent banner upon acceptance
  commonModule.hideCookieConsentBanner();

  /*
    Homepage-specific performance improvement in PSI (for red zone warning: excessive DOM size).
    To-do @aikansh: check how we can make this change across the entire website.
  */
  if (currentPathName === '/') {
    // Store references to DOM nodes
    const domNodesMap = {
      homepageParentNode: $('#parent-node-homepage'),
      homepageChildNode: $('#child-node-homepage'),
      footerParent: $('.site-content'),
      footer: $('footer'),
      mobileNavbarParentNode: $('#nav-mobile-collapse'),
      mobileNavbarChildNode: $('.mobile-dropdown-wrapper'),
      navProductParentNode: $('#nav-product-parent-node'),
      navProductChildNode: $('#nav-product-child-node')
    };

    // Remove content from the DOM (not visible on first page load) → improves PSI performance
    const removeSecondFoldFromDom = () => {
      domNodesMap.homepageChildNode.detach();
      domNodesMap.mobileNavbarChildNode.detach();
      domNodesMap.navProductChildNode.detach();
      domNodesMap.footer.detach();
    };
    removeSecondFoldFromDom();

    const attachSecondFoldToDom = () => {
      domNodesMap.homepageChildNode.appendTo(domNodesMap.homepageParentNode);
      domNodesMap.mobileNavbarChildNode.appendTo(domNodesMap.mobileNavbarParentNode);
      domNodesMap.navProductChildNode.appendTo(domNodesMap.navProductParentNode);
      domNodesMap.footer.appendTo(domNodesMap.footerParent);
    };
    /* As soon as the user interacts with the page
       (https://www.programmersought.com/article/45346595801/),
       append the deleted nodes back to the DOM and run functions which add functionality to components (required only after page load) */
    const addNodesToDom = () => {
      setTimeout(() => {
        // Append deleted nodes back to the DOM
        attachSecondFoldToDom();
        // Remove margin-top from footer
        commonModule.setFooterMargin();
        commonModule.carouselNormalization();
        commonModule.carouselTestimonial('#carousel');
        commonModule.carouselTestimonial('#clientCarousel');
        if (document.getElementById('customer-success-yt-videos')) {
          commonModule.videoCarousel();
        }
      }, 5);
    };

    window.addEventListener('touchstart', addNodesToDom, {
      once: true,
      passive: true
    });
    window.addEventListener('mousemove', addNodesToDom, { once: true });
    window.addEventListener('keydown', addNodesToDom, {
      once: true,
      passive: true
    });
  }

  // XERO integration code to fetch user profile
  if (window.location.href.indexOf('code') > -1) {
    const xeroHeaders = new Headers();
    xeroHeaders.append('Content-Type', 'application/json');
    const urlString = window.location.href,
      urlMain = new URL(urlString),
      codeNo = urlMain.searchParams.get('code');
    const rawData = JSON.stringify({
      code: codeNo,
      redirect_uri: window.location.href.split('?')[0]
    });
    const requestOptions = {
      method: 'POST',
      headers: xeroHeaders,
      body: rawData,
      redirect: 'follow'
    };
    let jsonData;
    const emailIdInput = document.getElementById('demo-email-outside-modal');
    const firstNameInput = document.getElementById('demo-first-name-outside-modal');
    fetch('https://xero-api.fyleapps.com/api/workspaces/external_signup/', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        jsonData = JSON.parse(result);
        emailIdInput.value = jsonData.user.email;
        emailIdInput.dispatchEvent(new Event('input'));
        firstNameInput.value = jsonData.user.given_name;
        firstNameInput.dispatchEvent(new Event('input'));
        const inputFields = document
          .getElementById('contact-us-form-outside-modal')
          .querySelectorAll('.mdc-text-field__input');
        for (let count = 0; count < inputFields.length; count++) {
          if (inputFields[count].value) {
            inputFields[count].classList.add('inputValueActive');
            inputFields[count].nextElementSibling.classList.add('mdc-floating-label--float-above');
          }
        }
      });
  }

  // Scripts for URLs having hash values on the product page
  if (window.location.href.indexOf('product') > -1) {
    // Smoothscroll
    $('.feature-navigation-link-block a[href^="#"]').on('click', (e) => {
      e.preventDefault();
      $(document).off('scroll');
      $('.feature-navigation-link-block a').each((index, element) => {
        $(element).removeClass('activeTab');
      });
      $(e.currentTarget).addClass('activeTab');

      const target = e.currentTarget.hash;
      const $target = $(target);
      $('html, body').animate(
        {
          scrollTop: $target.offset().top - 80
        },
        300,
        'swing',
        () => {
          $(document).on('scroll', onScroll);
        }
      );
    });

    const onScroll = () => {
      const scrollPosPage = $(document).scrollTop() + 100;
      $('.feature-navigation-link-block a').each((index, element) => {
        const currLink = $(element);
        const refElement = $(currLink.attr('href'));
        if (
          refElement.position().top <= scrollPosPage &&
          refElement.position().top + refElement.height() > scrollPosPage
        ) {
          $('.feature-navigation-link-block a').removeClass('activeTab');
          currLink.addClass('activeTab');
        } else {
          currLink.removeClass('activeTab');
        }
      });
    };
    $(document).on('scroll', onScroll);

    // Mobile nav product script
    $('.feature-navigation-link-block a').click(() => {
      $('.navToggle').removeClass('active');
      $('.features-filter-wrap').removeClass('open');
    });
    $('.navToggle').click(() => {
      $('.navToggle').toggleClass('active');
      $('.features-filter-wrap').toggleClass('open');
    });
  }

  // sticky-slider-animated-section
  const allowedPages = [
    '/ppc/expense-management/software',
    '/ppc/expense-software',
    '/ppc/small-business-expense-software'
  ];
  if (allowedPages.includes(currentPathName)) {
    window.addEventListener('scroll', () => {
      const element = document.getElementById('animated-scroll');
      const scrollPosition = window.scrollY;

      // const img1 = document.getElementById('image1');
      const img2 = document.getElementById('image2');
      const content1 = document.getElementById('content1');
      const content2 = document.getElementById('content2');
      const header1 = document.getElementById('slide1');
      const header2 = document.getElementById('slide2');

      const threshold = element.offsetTop - 60;

      if (scrollPosition >= threshold) {
        img2.classList.add('active');
        content2.classList.add('active');
        header2.classList.add('active');

        header1.classList.remove('active');
        content1.classList.add('inactive');
      } else {
        img2.classList.remove('active');
        content2.classList.remove('active');
        header2.classList.remove('active');

        header1.classList.add('active');
        content1.classList.remove('inactive');
      }
    });
  }
});
